import { Box, BoxProps, useStyleConfig, ThemingProps } from '@chakra-ui/react';

export interface CardProps extends BoxProps, ThemingProps {
  hoverable?: boolean;
}
export const CardTheme = {
  baseStyle: {
    px: 8,
    py: 12,
    background: 'bg.default',
    boxShadow: 'md',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 'base',
  },
  variants: {
    stats: {
      p: '16px',
      border: '1px solid',
      borderColor: 'border.decorative',
      background: 'bg.default',
    },
  },
};

export const Card = (props: CardProps) => {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig('Card', { variant });
  return (
    <Box __css={styles} {...rest}>
      {children}
    </Box>
  );
};
